/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ReportScheduleDto } from '../models/report-schedule-dto';
import { reportSchedulesGet$Json } from '../fn/report-schedules/report-schedules-get-json';
import { ReportSchedulesGet$Json$Params } from '../fn/report-schedules/report-schedules-get-json';
import { reportSchedulesGet$Plain } from '../fn/report-schedules/report-schedules-get-plain';
import { ReportSchedulesGet$Plain$Params } from '../fn/report-schedules/report-schedules-get-plain';
import { reportSchedulesPost$Json } from '../fn/report-schedules/report-schedules-post-json';
import { ReportSchedulesPost$Json$Params } from '../fn/report-schedules/report-schedules-post-json';
import { reportSchedulesPost$Plain } from '../fn/report-schedules/report-schedules-post-plain';
import { ReportSchedulesPost$Plain$Params } from '../fn/report-schedules/report-schedules-post-plain';
import { reportSchedulesScheduleIdDelete } from '../fn/report-schedules/report-schedules-schedule-id-delete';
import { ReportSchedulesScheduleIdDelete$Params } from '../fn/report-schedules/report-schedules-schedule-id-delete';
import { reportSchedulesScheduleIdGet$Json } from '../fn/report-schedules/report-schedules-schedule-id-get-json';
import { ReportSchedulesScheduleIdGet$Json$Params } from '../fn/report-schedules/report-schedules-schedule-id-get-json';
import { reportSchedulesScheduleIdGet$Plain } from '../fn/report-schedules/report-schedules-schedule-id-get-plain';
import { ReportSchedulesScheduleIdGet$Plain$Params } from '../fn/report-schedules/report-schedules-schedule-id-get-plain';
import { reportSchedulesScheduleIdPut$Json } from '../fn/report-schedules/report-schedules-schedule-id-put-json';
import { ReportSchedulesScheduleIdPut$Json$Params } from '../fn/report-schedules/report-schedules-schedule-id-put-json';
import { reportSchedulesScheduleIdPut$Plain } from '../fn/report-schedules/report-schedules-schedule-id-put-plain';
import { ReportSchedulesScheduleIdPut$Plain$Params } from '../fn/report-schedules/report-schedules-schedule-id-put-plain';

@Injectable({ providedIn: 'root' })
export class ReportSchedulesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportSchedulesGet()` */
  static readonly ReportSchedulesGetPath = '/report-schedules';

  /**
   * List report schedules.
   *
   * Lists all report schedules for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportSchedulesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesGet$Plain$Response(params?: ReportSchedulesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportScheduleDto>>> {
    const obs = reportSchedulesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List report schedules.
   *
   * Lists all report schedules for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportSchedulesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesGet$Plain(params?: ReportSchedulesGet$Plain$Params, context?: HttpContext): Observable<Array<ReportScheduleDto>> {
    const resp = this.reportSchedulesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ReportScheduleDto>>): Array<ReportScheduleDto> => r.body)
    );
  }

  /**
   * List report schedules.
   *
   * Lists all report schedules for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportSchedulesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesGet$Json$Response(params?: ReportSchedulesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportScheduleDto>>> {
    const obs = reportSchedulesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List report schedules.
   *
   * Lists all report schedules for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportSchedulesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesGet$Json(params?: ReportSchedulesGet$Json$Params, context?: HttpContext): Observable<Array<ReportScheduleDto>> {
    const resp = this.reportSchedulesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ReportScheduleDto>>): Array<ReportScheduleDto> => r.body)
    );
  }

  /** Path part for operation `reportSchedulesPost()` */
  static readonly ReportSchedulesPostPath = '/report-schedules';

  /**
   * Create report schedule.
   *
   * Creates a scheduled export for a query or dashboard.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportSchedulesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reportSchedulesPost$Plain$Response(params?: ReportSchedulesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
    const obs = reportSchedulesPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create report schedule.
   *
   * Creates a scheduled export for a query or dashboard.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportSchedulesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reportSchedulesPost$Plain(params?: ReportSchedulesPost$Plain$Params, context?: HttpContext): Observable<ReportScheduleDto> {
    const resp = this.reportSchedulesPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportScheduleDto>): ReportScheduleDto => r.body)
    );
  }

  /**
   * Create report schedule.
   *
   * Creates a scheduled export for a query or dashboard.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportSchedulesPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reportSchedulesPost$Json$Response(params?: ReportSchedulesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
    const obs = reportSchedulesPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create report schedule.
   *
   * Creates a scheduled export for a query or dashboard.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportSchedulesPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reportSchedulesPost$Json(params?: ReportSchedulesPost$Json$Params, context?: HttpContext): Observable<ReportScheduleDto> {
    const resp = this.reportSchedulesPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportScheduleDto>): ReportScheduleDto => r.body)
    );
  }

  /** Path part for operation `reportSchedulesScheduleIdGet()` */
  static readonly ReportSchedulesScheduleIdGetPath = '/report-schedules/{scheduleId}';

  /**
   * Get report schedule.
   *
   * Returns a report schedule configuration.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportSchedulesScheduleIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesScheduleIdGet$Plain$Response(params: ReportSchedulesScheduleIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
    const obs = reportSchedulesScheduleIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get report schedule.
   *
   * Returns a report schedule configuration.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportSchedulesScheduleIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesScheduleIdGet$Plain(params: ReportSchedulesScheduleIdGet$Plain$Params, context?: HttpContext): Observable<ReportScheduleDto> {
    const resp = this.reportSchedulesScheduleIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportScheduleDto>): ReportScheduleDto => r.body)
    );
  }

  /**
   * Get report schedule.
   *
   * Returns a report schedule configuration.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportSchedulesScheduleIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesScheduleIdGet$Json$Response(params: ReportSchedulesScheduleIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
    const obs = reportSchedulesScheduleIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get report schedule.
   *
   * Returns a report schedule configuration.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportSchedulesScheduleIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesScheduleIdGet$Json(params: ReportSchedulesScheduleIdGet$Json$Params, context?: HttpContext): Observable<ReportScheduleDto> {
    const resp = this.reportSchedulesScheduleIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportScheduleDto>): ReportScheduleDto => r.body)
    );
  }

  /** Path part for operation `reportSchedulesScheduleIdPut()` */
  static readonly ReportSchedulesScheduleIdPutPath = '/report-schedules/{scheduleId}';

  /**
   * Update report schedule.
   *
   * Updates schedule details, recipients and format.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportSchedulesScheduleIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reportSchedulesScheduleIdPut$Plain$Response(params: ReportSchedulesScheduleIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
    const obs = reportSchedulesScheduleIdPut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update report schedule.
   *
   * Updates schedule details, recipients and format.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportSchedulesScheduleIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reportSchedulesScheduleIdPut$Plain(params: ReportSchedulesScheduleIdPut$Plain$Params, context?: HttpContext): Observable<ReportScheduleDto> {
    const resp = this.reportSchedulesScheduleIdPut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportScheduleDto>): ReportScheduleDto => r.body)
    );
  }

  /**
   * Update report schedule.
   *
   * Updates schedule details, recipients and format.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportSchedulesScheduleIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reportSchedulesScheduleIdPut$Json$Response(params: ReportSchedulesScheduleIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
    const obs = reportSchedulesScheduleIdPut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update report schedule.
   *
   * Updates schedule details, recipients and format.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportSchedulesScheduleIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  reportSchedulesScheduleIdPut$Json(params: ReportSchedulesScheduleIdPut$Json$Params, context?: HttpContext): Observable<ReportScheduleDto> {
    const resp = this.reportSchedulesScheduleIdPut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportScheduleDto>): ReportScheduleDto => r.body)
    );
  }

  /** Path part for operation `reportSchedulesScheduleIdDelete()` */
  static readonly ReportSchedulesScheduleIdDeletePath = '/report-schedules/{scheduleId}';

  /**
   * Delete report schedule.
   *
   * Deletes a report schedule.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportSchedulesScheduleIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesScheduleIdDelete$Response(params: ReportSchedulesScheduleIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = reportSchedulesScheduleIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete report schedule.
   *
   * Deletes a report schedule.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportSchedulesScheduleIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportSchedulesScheduleIdDelete(params: ReportSchedulesScheduleIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.reportSchedulesScheduleIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
